import React from 'react';
import { Helmet } from 'react-helmet';
import Header from '../components/Header';
import Footer from '../components/Footer';

function GalleryWhiteLabel() {


    return (
        <div id="wrapper">

            {/* Header component */}
            <Header />

            <div className="no-bottom no-top" id="content">
                <div id="top"></div>

                <section id="profile_banner" aria-label="section" className="text-light" style={{ backgroundImage: 'url(https://media.niftygateway.com/image/upload/q_auto:good/v1706209038/publishers/niftygateway_curated/111644/create-drop/Screenshot%202024-01-25%20at%2010.57.15%20AM.webp)' }}>
                </section>

                <section aria-label="section" className="d_coll no-top">
                 
                </section>
            </div>

            {/* Footer */}
            <Footer />

        </div>
    );
}

export default GalleryWhiteLabel;